import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Header() {
    const { t } = useTranslation();
    const location = useLocation();

    if (location.pathname.startsWith('/dashboard')) return null;

    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-white/10">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 group">
                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-400 to-cyan-500 flex items-center justify-center text-white font-black text-sm shadow-lg shadow-emerald-500/25 group-hover:shadow-emerald-500/40 transition-shadow">
                        CS
                    </div>
                    <span className="text-lg font-bold text-white tracking-tight">{t('brand')}</span>
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    <a href="#features" className="text-sm text-white/60 hover:text-white transition-colors">
                        {t('nav.features')}
                    </a>
                    <a href="#steps" className="text-sm text-white/60 hover:text-white transition-colors">
                        {t('nav.demo')}
                    </a>
                </nav>

                <div className="flex items-center gap-3">
                    <Link
                        to="/auth"
                        className="text-sm text-white/70 hover:text-white transition-colors font-medium"
                    >
                        {t('nav.login')}
                    </Link>
                    <Link
                        to="/auth?mode=signup"
                        className="text-sm px-4 py-2 rounded-lg bg-gradient-to-r from-emerald-500 to-cyan-500 text-white font-semibold hover:from-emerald-400 hover:to-cyan-400 transition-all shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/40"
                    >
                        {t('nav.signup')}
                    </Link>
                </div>
            </div>
        </header>
    );
}
